/**
 * validateRutNumber
 *
 * This function formats a given string into a valid RUT-style format with specific rules:
 *
 * Allowed characters: A–Z, a–z, 0–9, and a single hyphen (final position controlled by logic)
 * All other characters (symbols, spaces, emojis, etc.) are removed.
 *
 **/

function validateRutNumber(input) {
//   if (!input) return "-";

  // Step 1: Keep only allowed characters (letters, digits, and hyphens)
  let cleaned = input.replace(/[^A-Za-z0-9-]/g, "");

  // Step 2: Remove all existing hyphens to normalize placement
  cleaned = cleaned.replace(/-/g, "");
  if (cleaned.length === 0) return "-";

  // Step 4: Limit raw string to a maximum of 9 characters
  // cleaned = cleaned.slice(0, 9);

  // Step 5: If the cleaned string has more than 1 character,
  // insert a single hyphen before the last character
  if (cleaned.length > 0) {
    cleaned = cleaned.slice(0, -1) + "-" + cleaned.slice(-1);
  }

  return cleaned;
}

export default validateRutNumber